import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { Store } from "../../types/modules/store.type";
import { getAdminAccessToken, getOwnerAccessToken } from "../../utils/auth";

export const useStoresByOnwer = (ownerId?: number) => {
  const token = ownerId ? getAdminAccessToken() : getOwnerAccessToken();
  const endPoint = ownerId
    ? `store/byOwner?ownerId=${ownerId}`
    : "store/byOwner";
  return useQuery({
    queryKey: ["stores-by-owner", ownerId],
    queryFn: () =>
      fetcher<{ stores: Store[]; hasIncompleteStore: boolean }>(
        endPoint,
        token
      ),
  });
};
